import React from 'react';
import Fade from 'react-reveal/Fade';
import './Baner.css'
import Typical from 'react-typical'


const Baner = () => {
    return (
        <div className="baner">
            

    <div className="parent mb-5">

<div className="d-flex text-center justify-content-center align-items-center h-100">
<div>
        <Fade top>
        <h3 style={{marginTop:'250px'}} className="text-white">“Hello”</h3> <br />
        </Fade>

         
         <h1 className='text-white'>I'm Hridoy Ahmed</h1>
      

  
    <h2 style={{color:'white'}}><Typical
        steps={['Web Developer',1000,'Web Designer',800,'React Developer',1000]}
        loop={Infinity}
        
      /></h2>
 




<div style={{marginTop:'50px',marginBottom:'100px'}}>

       <Fade bottom>
       <a href="#contact"><button style={{color:'black',padding:'8px',margin:'10px',width:'120px',backgroundColor:'#0FDCDC'}} className="btn  m-3 fw-bold" >CONTACT</button></a>
       
       <a target='blank' href="https://drive.google.com/file/d/1e9fgPCb8GzyaC4zZdtlVw8ZB8Xsv9VtM/view?usp=sharing"><button style={{color:'black',padding:'8px',margin:'10px',width:'120px',backgroundColor:'#0FDCDC'}} className="btn m-3 fw-bold">GET CV</button></a>


        </Fade>




</div>
</div>
</div>

</div>
            
        </div>
    );
};

export default Baner;